export enum ActivityStatus {
	InEvaluation = 1,
	TemporaryApproved = 2,
	Active = 3,
	Paused = 4,
	Canceled = 5,
	Declined = 6,
}

/**
 * Lifecycle action descriptor — used by the status change dialog. Imperative label
 * (e.g., "Aktyvuoti", "Sustabdyti"); flags whether the action requires an effective
 * date, accepts an optional one, and/or requires the decree number and date.
 *
 * Date semantics:
 *   - `requiresDate: true`  → date input rendered + required
 *   - `optionalDate: true`  → date input rendered + optional (Active uses this for ValidUntil)
 *   - both false            → date input hidden
 */
export interface ActivityStatusActionOption {
	id: ActivityStatus;
	label: string;
	requiresDate: boolean;
	optionalDate?: boolean;
	requiresDecree: boolean;
}

/** All possible lifecycle actions; the dialog filters by ACTIVITY_STATUS_TRANSITIONS. */
export const ACTIVITY_STATUS_ACTION_OPTIONS: ActivityStatusActionOption[] = [
	{ id: ActivityStatus.Active, label: 'Aktyvuoti', requiresDate: false, optionalDate: true, requiresDecree: true },
	{ id: ActivityStatus.TemporaryApproved, label: 'Laikinai patvirtinti', requiresDate: true, requiresDecree: true },
	{ id: ActivityStatus.Paused, label: 'Sustabdyti', requiresDate: true, requiresDecree: true },
	{ id: ActivityStatus.Canceled, label: 'Išregistruoti', requiresDate: true, requiresDecree: true },
	{ id: ActivityStatus.Declined, label: 'Atmesti', requiresDate: false, requiresDecree: false },
];

/**
 * Status state machine: keys are current statuses, values are allowed next statuses.
 * `Canceled` and `Declined` are terminal (empty arrays).
 */
export const ACTIVITY_STATUS_TRANSITIONS: Record<ActivityStatus, ActivityStatus[]> = {
	[ActivityStatus.InEvaluation]: [ActivityStatus.Active, ActivityStatus.TemporaryApproved, ActivityStatus.Declined],
	[ActivityStatus.TemporaryApproved]: [
		ActivityStatus.TemporaryApproved,
		ActivityStatus.Active,
		ActivityStatus.Canceled,
	],
	[ActivityStatus.Active]: [ActivityStatus.Active, ActivityStatus.Paused, ActivityStatus.Canceled],
	[ActivityStatus.Paused]: [ActivityStatus.Active, ActivityStatus.Paused, ActivityStatus.Canceled],
	[ActivityStatus.Canceled]: [],
	[ActivityStatus.Declined]: [],
};
